import { render, staticRenderFns } from "./InfoBhist.vue?vue&type=template&id=2b5159be&"
import script from "./InfoBhist.vue?vue&type=script&lang=js&"
export * from "./InfoBhist.vue?vue&type=script&lang=js&"
import style0 from "./InfoBhist.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports